import axios from 'axios';
import { API_URL } from '../constants/index.js';
import { useInterceptor } from './apiUtils';

useInterceptor(axios);

export function createSharedRentalInterest(data) {
  return axios({
    method: 'post',
    url: `${API_URL}/shared_rental_interests`,
    data: { shared_rental_interest: data }
  });
}

export function getSharedRentalInterests(params) {
  return axios({ method: 'get', url: `${API_URL}/shared_rental_interests`, params: params || {} });
}

export function showSharedRentalInterest(id) {
  return axios({ method: 'get', url: `${API_URL}/shared_rental_interests/${id}` });
}

export function updateSharedRentalInterest(id, data) {
  return axios({
    method: 'put',
    url: `${API_URL}/admin/shared_rental_interests/${id}`,
    data: { shared_rental_interest: data }
  });
}

export function markRestPaidSharedRental(id, offlinePayment = {}) {
  return axios({
    method: 'put',
    url: `${API_URL}/admin/shared_rental_interests/${id}`,
    data: {
      shared_rental_interest: { status: 'rest_paid' },
      offline_payment: offlinePayment
    }
  });
}

export function sendRestPaymentLink(id) {
  return axios({ method: 'post', url: `${API_URL}/admin/shared_rental_interests/${id}/send_rest_link` });
}

export function sendInterestLink(id) {
  return axios({ method: 'post', url: `${API_URL}/admin/shared_rental_interests/${id}/send_interest_link` });
}

export function refundSharedRentalInterest(id) {
  return axios({ method: 'post', url: `${API_URL}/admin/shared_rental_interests/${id}/refund` });
}

export function markInterestPaidSharedRental(id, offlinePayment = {}) {
  return axios({
    method: 'post',
    url: `${API_URL}/admin/shared_rental_interests/${id}/mark_interest_paid`,
    data: { offline_payment: offlinePayment }
  });
}

export function getRestPaymentInfo(id) {
  return axios({ method: 'get', url: `${API_URL}/shared_rental_interests/${id}/rest_payment_info` });
}

export function getInterestPaymentInfo(id) {
  return axios({ method: 'get', url: `${API_URL}/shared_rental_interests/${id}/interest_payment_info` });
}

export function initiateRestPayment(id) {
  return axios({ method: 'post', url: `${API_URL}/shared_rental_interests/${id}/initiate_rest_payment` });
}

export function getMySharedRentalInterests() {
  return axios({ method: 'get', url: `${API_URL}/shared_rental_interests/my` });
}

export function updateNumberOfPeople(id, number_of_people) {
  return axios({
    method: 'put',
    url: `${API_URL}/shared_rental_interests/${id}/update_number_of_people`,
    data: { number_of_people }
  });
}

export function cancelSharedRentalInterest(id) {
  return axios({ method: 'patch', url: `${API_URL}/shared_rental_interests/${id}/cancel` });
}
